
/**
 * Helper utilities specific to Level 1 scoring
 */

export const isSpecialPuttsTest = (testId: string | null): boolean => {
  return testId === "putts-plat" && ["G", "H", "I"].includes(window.location.pathname);
};

export const getFormattedPoint = (point: string): string => {
  if (point === "G") return "Point G - 6m";
  if (point === "H") return "Point H - 10m";
  if (point === "I") return "Point I - 12m";
  
  return `Point ${point}`;
};
